import React from 'react';

interface ProgressBarProps {
    step: number;
    onGoBack: () => void;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ step, onGoBack }) => {
    const steps = ['Choose Plan', 'User Info', 'Payment'];
    return (
        <div className="mb-8 font-cinzel">
            <div className="flex justify-between">
                {steps.map((s, i) => (
                    <div key={i} className={`text-medium font-bold ${i <= step ? 'text-terracotta' : 'text-stone-dark'}`}>
                        {s}
                    </div>
                ))}
            </div>
            <div className="mt-2 h-3 flex rounded-full bg-stone-light overflow-hidden relative">
                <div
                    className="absolute top-0 left-0 h-full bg-terracotta transition-all duration-300 ease-in-out"
                    style={{ width: `${((step + 1) / steps.length) * 100}%` }}
                ></div>
                {steps.map((_, i) => (
                    <div
                        key={i}
                        className="h-full border-r border-stone-dark last:border-r-0 z-10"
                        style={{ width: `${100 / steps.length}%` }}
                    ></div>
                ))}
            </div>
            {step > 0 && (
                <button
                    onClick={onGoBack}
                    className="mt-4 px-4 py-2 bg-terracotta text-warm-cream text-sm font-semibold rounded-full hover:bg-golden-yellow hover:text-greek-black transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-golden-yellow focus:ring-offset-2 font-cinzel"
                >
                    Go Back
                </button>
            )}
        </div>
    );
};

export default ProgressBar;